import { Box, Button, Paper, Typography, Alert, AlertTitle } from '@mui/material';
import SellerSalesByMonth from './sellersSalesByMonth';
import ListSalesMonth from './listSalesMonth';
import SalesStatus from './salesStatus';
import SalesByClient from './salesByClient';
import styled from 'styled-components';
import theme from 'core/theme/theme';
import { useState } from 'react';
import GroupIcon from '@mui/icons-material/Group';
import SellIcon from '@mui/icons-material/Sell';
import CategoryProductsDashboard from './CategoryProductsDashboard';
import ReportItems from './reportItems';
import ReportProducts from './reportProducts';
import CategoryIcon from '@mui/icons-material/Category';
import BlockIcon from '@mui/icons-material/Block';
import { useAppSelector } from 'core/hooks/reduxHooks';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {

    const [indexDashboard, setIndexDashboard] = useState(0)
    const basicUserInfo = useAppSelector((state) => state.auth.userInfo);
    const navigate = useNavigate();
    
    const dashboardOptions = [
        {
            title: 'Vendedores',
            icon: GroupIcon,
            action: () => setIndexDashboard(0)
        },
        {
            title: 'Produtos',
            icon: SellIcon,
            action: () => setIndexDashboard(1)
        },
        {
            title: 'Categorias',
            icon: CategoryIcon,
            action: () => setIndexDashboard(2)
        },
    ]

    // Verifica se o usuário tem permissão
    const hasSellerRole = basicUserInfo?.roles?.includes("ROLE_ADMIN");

    // Se não tiver permissão, mostra componente de acesso negado
    if (!hasSellerRole) {
        return (
            <AccessDeniedContainer>
                <Alert severity="error" sx={{ maxWidth: 600, width: '100%' }}>
                    <AlertTitle>Acesso Negado</AlertTitle>
                    Você não tem permissão para acessar o Dashboard. 
                    Esta área é restrita apenas para vendedores.
                </Alert>
                
                <AccessDeniedCard>
                    <BlockIcon sx={{ fontSize: 64, color: theme.COLORS.YELLOW2, mb: 2 }} />
                    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, color: theme.COLORS.YELLOW2 }}>
                        Acesso Restrito
                    </Typography>
                    <Typography variant="body1" sx={{ textAlign: 'center', mb: 3, color: '#666' }}>
                        Para acessar o Dashboard, você precisa ter privilégios de admin. 
                        Entre em contato com o administrador do sistema para solicitar acesso.
                    </Typography>
                    
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button 
                            variant="outlined" 
                            onClick={() => navigate(-1)}
                             sx={{ 
                                backgroundColor: theme.COLORS.YELLOW2, color : theme.COLORS.WHITE,
                                '&:hover': {
                                    backgroundColor: theme.COLORS.YELLOW2,
                                    opacity: 0.8
                                }
                            }}
                        >
                            Voltar
                        </Button>
                    </Box>
                </AccessDeniedCard>
            </AccessDeniedContainer>
        );
    }

    return (
        <Box
            sx={{
                padding: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: '2rem',
                margin: '0 1rem 0 1rem',
                background: theme.COLORS.WHITE,
            }}
        >
            <DashboardHeader>
                {dashboardOptions.map((item, index) => (
                    <DashboardButton
                        key={index}
                        title={item.title}
                        onClick={item.action}
                        isActive={index === indexDashboard}
                    >
                        <item.icon />
                        {item.title}
                    </DashboardButton>
                ))}
            </DashboardHeader>

            {indexDashboard === 0 &&
                <>
                    <ItemTitle>
                        Status de Vendas por Vendedor
                    </ItemTitle>

                    <SalesStatus />

                    <ItemTitle>
                        Vendas por Forma de Pagamento
                    </ItemTitle>

                    <SellerSalesByMonth />

                    <ItemTitle>
                        Análise Mensal de Vendas
                    </ItemTitle>

                    <ListSalesMonth />

                </>
            }
            {indexDashboard === 1 &&
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5rem' }}>
                    {/* <ReportItems /> */}
                    <ReportProducts />
                </Box>
            }
            {indexDashboard === 2 &&
                <>
                    <CategoryProductsDashboard />
                </>
            }
        </Box>
    );
}

// Styled Components existentes
const ItemTitle = styled(Typography)`
    font-weight: bolder !important;
    width: 100% !important;
    text-align: center !important;
    font-size: 22px !important;
    color: ${theme.COLORS.YELLOW2} !important;
`;

const DashboardHeader = styled(Box)`
    display: flex !important;
    justify-content: flex-start !important;
    align-items: center !important;
    padding: 0.5rem !important;
    width: 100% !important;
    gap: 1rem !important;
`;

const DashboardButton = styled(Button)<{ isActive: boolean }>`
    color: ${(props) => (props.isActive ? theme.COLORS.WHITE_100 : theme.COLORS.YELLOW2)} !important;
    background-color: ${(props) => (props.isActive ? theme.COLORS.YELLOW2 : theme.COLORS.WHITE_100)} !important;
    border-radius: 5px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 5px !important;
    border: 1px solid ${theme.COLORS.YELLOW2} !important;
`;

// Novos Styled Components para o acesso negado
const AccessDeniedContainer = styled(Box)`
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    min-height: 80vh !important;
    padding: 2rem !important;
    gap: 2rem !important;
    background: ${theme.COLORS.WHITE} !important;
`;

const AccessDeniedCard = styled(Paper)`
    padding: 3rem !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    text-align: center !important;
    max-width: 500px !important;
    width: 100% !important;
    border: 2px solid ${theme.COLORS.YELLOW2} !important;
    border-radius: 12px !important;
`;